export const male_gloves = [ //An array of each Male Glove's ID, Atlas file, and name. There are 8.
  {
    id: 'glove0', //Append either vb_frontarm_hand or vb_backarm_hand to find class.
    atlas: 'atlas18', //Append to atlas to find class.
    name: 'No gloves' //Show name in textbox.
  },
  {
    id: 'glove3',
    atlas: 'atlas18',
    name: 'Something metal?'
  },
  {
    id: 'glove5',
    atlas: 'atlas18',
    name: 'BoS uniform'
  },
  {
    id: 'glove8',
    atlas: 'atlas18',
    name: 'Durable gloves' /* Radiation suit, Minuteman uniform. */
  },
  {
    id: 'glove9',
    atlas: 'atlas18',
    name: 'Boxing gloves'
  },
  {
    id: 'glove11',
    atlas: 'atlas18',
    name: 'Baseball gloves'
  },
  {
    id: 'glove12',
    atlas: 'atlas18',
    name: 'Power armor gloves'
  },
  {
    id: 'glove13',
    atlas: 'atlas18',
    name: 'Phalanges gloves' /* Skeleton costume. */
  },

  /* Closed gloves */
  // {
  //   id: 'glove1',
  //   atlas: 'atlas18',
  //   name: '???'
  // },
  // {
  //   id: 'glove6',
  //   atlas: 'atlas18',
  //   name: '???'
  // },
  // {
  //   id: 'glove7',
  //   atlas: 'atlas18',
  //   name: '???'
  // },
  // {
  //   id: 'glove10',
  //   atlas: 'atlas18',
  //   name: '???'
  // },
  // {
  //   id: 'glove14',
  //   atlas: 'atlas18',
  //   name: '???'
  // }
]